export const smallDialog = {
    minHeight: '325px',
};

export const mediumDialog = {
    minHeight: '450px',
};

export const largeDialog = {
    minHeight: '550px',
};
